import { XSSFilterOptions } from './../../../common/XSSFilterOptions'
import ColorConstants from '@/common/ColorConstants'
import { Component, Vue } from 'vue-property-decorator'
import CABG1020ViewModel from './CABG1020ViewModel'
import CABG1020Service from './CABG1020Service'
import CACG1060ParamModel from '@/views/CAC/CACG1060/CACG1060ParamModel'
import CACG1110ParamModel from '@/views/CAC/CACG1110/CACG1110ParamModel'
import { FormatConstants } from '@/common/FormatConstants'
import CommonConstants from '@/common/CommonConstants'
import SessionStorageService from '@/common/SessionStorageService'
import 'simplebar'
import 'simplebar/dist/simplebar.css'
import ValidateUtil from '@/common/utils/ValidationUtil'
import CommonUtil from '@/common/utils/CommonUtil'
import Store from '@/common/utils/Store'
import TransportService from '@/common/TransportService'
import { fixedContent } from '@/assets/js/main.js'
import { normalizeHeightTable } from '@/assets/js/components/table.js'
import $ from 'jquery'
import { FullPageLoading } from '@/components/common/loading/full-page-loading'
@Component({
  name: 'CABG1020',
  components: {}
  })
export default class CABG1020Controller extends Vue {
  private isCompleteLoading = false
  private showLoginModalFlg = false
  private CommonConstants = CommonConstants
  private FormatConstants = FormatConstants
  private ValidateUtil = ValidateUtil
  private XSSFilterOptions = XSSFilterOptions
  private validateFormErrors = []
  private showReferenceDate = false
  private listProductDiv = [
    '180',
    '050',
    '040',
    '060',
    '030',
    '020',
    '070',
    '100',
    '090',
    '150',
    '160',
    '200',
    '999',
    '190'
  ]

  private cabg1020ViewModel: CABG1020ViewModel = {
    monthlyPrem: {
      nowPrem: null,
      nowPremUnit: '円',
      empPrem: null,
      empPremUnit: '円',
      joinerPrem: null,
      joinerPremUnit: '円',
      storagePlanFee: null,
      storagePlanFeeUnit: '円',
      invesitingAssetsValue: null,
      invesitingAssetsValueUnit: '円',
      nxtContrDay: '',
      matchContrFlg: '',
      cntctUnitDiv: ''
    },
    operatPricDetail: {
      operatPric: null,
      operatPricUnit: '円',
      regularContrPrem: null,
      regularContrPremUnit: '円',
      sysTransitPric: null,
      sysTransitPricUnit: '円',
      acceptPric: null,
      acceptPricUnit: '円',
      benftTransPric: null,
      benftTransPricUnit: '円',
      fee: '',
      feeUnit: '円'
    },
    premDistAssignSts: {
      productInfoLst: [
        {
          assetDiv: '',
          assetColor: '',
          assetDivName: '',
          productName: '',
          distRatio: null,
          distRatioUnit: '',
          distPric: null,
          distPricUnit: '',
          handProductNo: '',
          priCompProductCd: '',
          rkShhnCd: ''
        }
      ]
    },
    dataContrAlloDesignStt: [],
    nxtContrDayTxt: '',
    referenceDate: '',
    specifiedOpeFlg: '',
    noContributedNorAnyDistributionFlg: '',
    yesContributedNorAnyDistributionFlg: '',
    contributionCycle: '',
    needJistAuthFlag: '',
    jistApiCollectMes: {
      code: '',
      message: ''
    },
    formLogin: {
      joinerAccNo: '',
      password: ''
    },
    baseUrl: '',
    clientID: '',
    gustIDDiv: ''
  }

  private cabg1020Service: CABG1020Service = new CABG1020Service()

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    this.$nextTick(() => {
      fixedContent()
      normalizeHeightTable()
    })
  }

  /**
   * 初期処理
   */
  private async init() {
    // 共通メソッド「ローディング表示」を呼び出す。
    const loading = new FullPageLoading()
    loading.show()

    const cntctUnitDiv = JSON.parse(
      SessionStorageService.getItem(CommonConstants.USER_INFO)
    ).userInfo.cntctUnitDiv
    const gustIDDiv = JSON.parse(
      SessionStorageService.getItem(CommonConstants.USER_INFO)
    ).userInfo.gustIDDiv
    this.cabg1020ViewModel.monthlyPrem.cntctUnitDiv = cntctUnitDiv.toString()
    let caba1020ResponseModel = null
    const errorCode = this.$route.query.errorCode?.toString()
    const messageError = []
    if (errorCode !== undefined) {
      messageError.push({
        code: errorCode,
        message: CommonUtil.getMessage(errorCode, []),
        url: ''
      })
    }

    if (gustIDDiv === '1') {
      caba1020ResponseModel = await this.cabg1020Service.callAPICABA1020()
    } else {
      if (errorCode !== undefined) {
        const jistApiCollectMes = JSON.parse(
          SessionStorageService.getItem(CommonConstants.JIST_API_COLLECT_MES)
        )
        if (jistApiCollectMes) {
          this.cabg1020ViewModel.jistApiCollectMes = jistApiCollectMes
        }

        if (!CommonConstants.LIST_ERROR_CODE_NOT_DISPLAY.includes(errorCode)) {
          Store.setResponseErrors(messageError)
        }
        if (jistApiCollectMes && !CommonConstants.LIST_ERROR_CODE_JIST_API_NOT_ALLOW.includes(errorCode)) {
          this.cabg1020ViewModel.needJistAuthFlag = '1'
        }
      } else {
        caba1020ResponseModel = await this.cabg1020Service.callAPICABA1020()
      }

      if (
        caba1020ResponseModel?.needJistAuthFlag === '1' ||
        this.cabg1020ViewModel.needJistAuthFlag === '1'
      ) {
        const extInfoResponseModel = await this.cabg1020Service.callAPIExtInfo()
        this.cabg1020ViewModel.baseUrl = extInfoResponseModel?.baseUrl
        this.cabg1020ViewModel.clientID = extInfoResponseModel?.clientID
      }
    }

    // 共通メソッド「ローディングクローズ」を呼び出す。
    loading.close()

    // APIエラー表示設定
    if (caba1020ResponseModel?.common?.status === CommonConstants.RESPONSE_STATUS_ERROR) {
      const jistApiCollectMesSession = JSON.parse(
        SessionStorageService.getItem(CommonConstants.JIST_API_COLLECT_MES)
      )

      if (jistApiCollectMesSession !== null) {
        this.cabg1020ViewModel.jistApiCollectMes = jistApiCollectMesSession
      }

      caba1020ResponseModel.common.errors.forEach(e => {
        if (!CommonConstants.LIST_ERROR_CODE_NOT_DISPLAY.includes(e.code)) {
          messageError.push({
            code: e.code,
            message: e.message,
            url: ''
          })
        } else {
          const jistApiCollectMes = {
            code: e.code,
            message: e.message
          }
          if (jistApiCollectMesSession === null) {
            SessionStorageService.setItem(
              CommonConstants.JIST_API_COLLECT_MES,
              JSON.stringify(jistApiCollectMes)
            )
            this.cabg1020ViewModel.jistApiCollectMes = jistApiCollectMes
          } else {
            this.cabg1020ViewModel.jistApiCollectMes.message = e.message
          }
        }
      })
      if (messageError) {
        Store.setResponseErrors(messageError)
      }
    } else if (caba1020ResponseModel !== null) {
      SessionStorageService.removeItem(CommonConstants.JIST_API_COLLECT_MES)
    }

    if (caba1020ResponseModel) {
      if (caba1020ResponseModel.monthlyPrem) {
        this.cabg1020ViewModel.monthlyPrem = caba1020ResponseModel.monthlyPrem
      }

      if (caba1020ResponseModel.operatPricDetail) {
        this.cabg1020ViewModel.operatPricDetail =
          caba1020ResponseModel.operatPricDetail
      }

      if (
        CommonUtil.isNotEmpty(
          caba1020ResponseModel?.premDistAssignSts?.productInfoLst
        )
      ) {
        this.cabg1020ViewModel.premDistAssignSts.productInfoLst.shift()
        caba1020ResponseModel.premDistAssignSts.productInfoLst.forEach(
          (item) => {
            const data = { ...item }
            data.assetColor =
              ColorConstants.ASSET_CODE[data.assetDiv] ??
              ColorConstants.DEFAULT_COLOR
            this.cabg1020ViewModel.premDistAssignSts.productInfoLst.push(data)
          }
        )
      } else {
        this.cabg1020ViewModel.premDistAssignSts = null
      }

      this.cabg1020ViewModel.specifiedOpeFlg =
        caba1020ResponseModel.specifiedOpeFlg
      this.cabg1020ViewModel.noContributedNorAnyDistributionFlg =
        caba1020ResponseModel.noContributedNorAnyDistributionFlg
      this.cabg1020ViewModel.yesContributedNorAnyDistributionFlg =
        caba1020ResponseModel.yesContributedNorAnyDistributionFlg
      this.cabg1020ViewModel.contributionCycle =
        caba1020ResponseModel.contributionCycle
      this.cabg1020ViewModel.needJistAuthFlag =
        caba1020ResponseModel.needJistAuthFlag
      this.cabg1020ViewModel.gustIDDiv = gustIDDiv

      if (this.cabg1020ViewModel.premDistAssignSts) {
        this.cabg1020ViewModel = this.cabg1020Service.fomatDataChart(
          this.cabg1020ViewModel
        )
      }

      const userInfo = JSON.parse(
        SessionStorageService.getItem(CommonConstants.USER_INFO)
      )?.userInfo

      this.cabg1020ViewModel.referenceDate = userInfo?.referenceDate
    } else {
      this.cabg1020ViewModel.premDistAssignSts = null
    }
    this.cabg1020ViewModel = this.cabg1020Service.setDisplayTextLabel(
      this.cabg1020ViewModel
    )
    if (
      caba1020ResponseModel?.monthlyPrem !== null ||
      caba1020ResponseModel?.operatPricDetail !== null ||
      caba1020ResponseModel?.premDistAssignSts !== null
    ) {
      this.showReferenceDate = true
    }
    this.isCompleteLoading = true
  }

  /**
   * 「運用状況（資産）」（CABG1010）画面に遷移する。
   */
  private gotoCABG1010() {
    this.$router.push({ name: 'cabg1010' })
  }

  /**
   * 「運用状況（利回り）」（CABG1030）画面に遷移する。
   */
  private gotoCABG1030() {
    this.$router.push({ name: 'cabg1030' })
  }

  /**
   *  外部サイト：JIS＆Tログインを別タブで表示する。
   * @param transportUrl
   */
  private gotoJIST(transportUrl, paramEvent) {
    if (CommonUtil.isGuestUser()) {
      const message = CommonUtil.getMessage('MSGCABG1020WF001', [])
      const messageErrorArr = []
      messageErrorArr.push({
        code: 'MSGCABG1020WF001',
        message: message,
        url: ''
      })
      Store.setResponseErrors(messageErrorArr)
    } else {
      TransportService.callAPITransport(transportUrl, null, null)
      CommonUtil.gotoJISTSite(paramEvent)
    }
  }

  /**
   * 商品分類に紐づく、該当する商品詳細画面に遷移する。
   * @param assetDiv
   * @param handProductNo
   * @param priCompProductCd
   * @param rkShhnCd
   */
  private gotoProductDetail(
    assetDiv: string,
    handProductNo: string,
    priCompProductCd: number,
    rkShhnCd: ''
  ) {
    const cacg1060ParamModel: CACG1060ParamModel = {
      productNo: rkShhnCd,
      shhnCd: priCompProductCd.toString()
    }

    const cacg1110ParamModel: CACG1110ParamModel = {
      productNo: rkShhnCd,
      shhnCd: priCompProductCd.toString()
    }
    switch (assetDiv) {
      case '020':
      case '030':
      case '040':
      case '050':
      case '060':
      case '070':
      case '090':
      case '100':
      case '150':
      case '160':
        this.$router.push({ name: 'cacg1060', query: cacg1060ParamModel })
        break
      case '999':
        if (handProductNo !== '999') {
          this.$router.push({ name: 'cacg1060', query: cacg1060ParamModel })
        }
        break
      case '180':
        this.$router.push({ name: 'cacg1110', query: cacg1110ParamModel })
        break
    }
  }

  /**
   * 外部サイト：個人型確定拠出年金 iDeCo（URL:https://selfs.dai-ichi-life.co.jp/dc/personal/）を別タブで表示する。
   */
  private gotoOperationJIST(paramEvent) {
    if (CommonUtil.isGuestUser()) {
      const message = CommonUtil.getMessage('MSGCABG1020WF001', [])
      const messageErrorArr = []
      messageErrorArr.push({
        code: 'MSGCABG1020WF001',
        message: message,
        url: ''
      })
      Store.setResponseErrors(messageErrorArr)
    } else {
      CommonUtil.gotoJISTSite(paramEvent)
    }
  }

  /**
   * データがリンクされているかどうかを確認します
   * @param assetDiv
   * @param handProductNo
   */
  private isLink(assetDiv, handProductNo) {
    if (this.listProductDiv.indexOf(assetDiv) >= 0) {
      if (assetDiv !== '999' || handProductNo !== '999') {
        return true
      }
    }
    return false
  }

  /**
   * JIS&T API連携許可はこちらボタン押下
   */
  private openModalLoginJIST() {
    this.showLoginModalFlg = true

    // リセットエラーメッセージ
    this.validateFormErrors = []
    this.cabg1020ViewModel.formLogin.joinerAccNo = ''
    this.cabg1020ViewModel.formLogin.password = ''

    // 有効化ボタン
    this.$nextTick(() => {
      const btnLoginSSO = this.$refs.btnLoginSSO as HTMLButtonElement
      btnLoginSSO.disabled = false
    })

    $('.el-dialog__close').attr('tabindex', '60')
    this.$nextTick(() => {
      const modal = document.getElementById('loginModal')
      const firstFocusableElement = document.querySelector(
        '.bg-login'
      ) as HTMLInputElement
      const lastFocusableElement = document.querySelector(
        '.el-dialog__close'
      ) as HTMLInputElement

      firstFocusableElement.focus()
      modal.addEventListener('keydown', function(e) {
        const isTabPressed = e.key === 'Tab'
        if (!isTabPressed) {
          return
        }
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus()
            e.preventDefault()
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus()
            e.preventDefault()
          }
        }
      })
    })
  }

  /**
   * 認証ボタン押下
   */
  private async loginApiSSO() {
    this.validateFormErrors = this.cabg1020Service.validationLoginSSO(
      this.cabg1020ViewModel
    )
    if (this.validateFormErrors.length === 0) {
      // 有効化ボタン
      const btnLoginSSO = this.$refs.btnLoginSSO as HTMLButtonElement
      btnLoginSSO.disabled = true

      const inputClientId = this.$refs.client_id as HTMLInputElement
      inputClientId.value = this.cabg1020ViewModel.clientID
      const inputReurl = this.$refs.reurl as HTMLInputElement
      inputReurl.value =
        process.env.VUE_APP_BASE_URL_DLS +
        process.env.VUE_APP_REURL_JIST_API_LOGIN
      const inputSesst = this.$refs.sesst as HTMLInputElement
      inputSesst.value = CommonConstants.JIST_API_SSO_PARAMETER_SESST

      const form = this.$refs.form as HTMLFormElement
      form.method = 'POST'
      form.action =
        this.cabg1020ViewModel.baseUrl + process.env.VUE_APP_JIST_API_SSO_LOGIN
      form.target = '_self'
      form.acceptCharset = CommonConstants.JIST_API_SSO_FORM_CHARSET
      form.enctype = CommonConstants.JIST_API_SSO_FORM_ENCTYPE

      setTimeout(
        () => {
          // 有効化ボタン
          btnLoginSSO.disabled = false
          form.submit()
        }, 1000
      )
    } else {
      $('.modal-content').animate(
        {
          scrollTop: 0
        },
        0
      )
    }
  }

  /**
   * ポップアップの「×」ボタン押下
   */
  private closeModalLoginJIST() {
    this.showLoginModalFlg = false
  }
}
